var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-orders-index"
  }, [_vm.fetching ? _c('p', [_c('Loading')], 1) : [_c('Hero', {
    attrs: {
      "title": "消費紀錄"
    }
  }), _c('div', {
    staticClass: "s-bg-white s-mb-6"
  }, [_c('header', {
    staticClass: "s-p-3 s-border-b s-border-gray-light"
  }, [_c('PeriodSelect', {
    attrs: {
      "value": _vm.months
    },
    on: {
      "change": _vm.setMonths
    }
  })], 1), _c('main', {
    staticClass: "s-px-3"
  }, [_c('p', {
    staticClass: "s-text-xs s-text-center s-pt-3"
  }, [_vm._v(" 交易紀錄將於 60 分鐘後更新，實際資料以本公司系統紀錄為準 ")]), _vm.transactions.length ? _c('ul', {
    staticClass: "s-divide-y s-divide-y-gray-light"
  }, _vm._l(_vm.transactions, function (transaction, i) {
    return _c('Item', {
      key: i,
      attrs: {
        "transaction": transaction
      }
    });
  }), 1) : _c('div', {
    staticClass: "s-py-40 s-text-center"
  }, [_c('img', {
    staticClass: "s-mb-3",
    attrs: {
      "src": require("@/assets/images/liff/empty.svg")
    }
  }), _c('p', {
    staticClass: "s-text-gray"
  }, [_vm._v("沒有消費紀錄")])])])]), _c('Pagination', {
    attrs: {
      "current": _vm.page,
      "last": _vm.lastPage
    }
  })]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }